import { CSSProperties, useState } from "react";

import classNames from "classnames";
import capitalize from "lodash/capitalize";
import { useTranslation } from "react-i18next";

import bestOfTheBestFallbackImage from "components/ui/assets/images/ta_best_of_the_best.png";
import travelersChoiceFallbackImage from "components/ui/assets/images/ta_travelers_choice.png";
import { Image } from "components/ui/source";

import { TripadvisorAward, TripadvisorAwardTypeEnum } from "types/graphql";

import styles from "./TripadvisorAwardBadge.module.scss";

const fallbackImagesByAwardType: Record<TripadvisorAwardTypeEnum, string> = {
  [TripadvisorAwardTypeEnum.TravelersChoice]: travelersChoiceFallbackImage,
  [TripadvisorAwardTypeEnum.BestOfTheBest]: bestOfTheBestFallbackImage,
};

export interface Props {
  tripadvisorAward: TripadvisorAward;
  style?: CSSProperties;
  className?: string;
  innerRef?: React.Ref<HTMLDivElement>;
}

export const TripadvisorAwardBadge = ({
  tripadvisorAward,
  style,
  className,
  innerRef,
}: Props) => {
  const { t } = useTranslation();

  const [imgSrc, setImgSrc] = useState(tripadvisorAward.assetSrc);

  return (
    <div
      ref={innerRef}
      className={classNames(styles.badgeContainer, className)}
      style={style}
    >
      <Image
        onErrorCapture={() => {
          setImgSrc(fallbackImagesByAwardType[tripadvisorAward.awardType]);
        }}
        contain
        src={imgSrc}
        alt={t("common:tripadvisorBadge.altImageText", {
          awardTypeReadable: capitalize(
            tripadvisorAward.awardType.replace("_", " "),
          ),
        })}
      />
    </div>
  );
};
